import { render, staticRenderFns } from "./ProfileFollow.vue?vue&type=template&id=bbeffd50&"
import script from "./ProfileFollow.vue?vue&type=script&lang=js&"
export * from "./ProfileFollow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports